// AUTO-GENERATED — run: node scripts/sync-snippets.js
// Do not edit this file directly. Edit files in snippets/ or the integration's app/ directory instead.
export const snippets = {
  'card-element': {
    'js': {
      html: `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title>Stripe Card Element</title>
    <script src="https://js.stripe.com/v3/"></script>
    <link rel="stylesheet" href="styles.css" />
  </head>
  <body>
    <h1>Stripe Card Element</h1>
    <form id="payment-form">
      <div id="card-element"></div>
      <div id="card-errors"></div>
      <button id="submit">Pay now</button>
    </form>
    <div id="payment-message"></div>
    <script src="frontend.js"></script>
  </body>
</html>
`,
      styles: `body {
  font-family: sans-serif;
  max-width: 500px;
  margin: 60px auto;
  padding: 0 20px;
}

h1 {
  margin-bottom: 24px;
}

#card-element {
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 12px;
}

#card-errors {
  color: #df1b41;
  font-size: 14px;
  margin-bottom: 12px;
}

button {
  width: 100%;
  padding: 12px;
  background: #635bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}

button:hover {
  background: #5851eb;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

#payment-message {
  margin-top: 16px;
  color: #30a652;
  font-size: 14px;
}
`,
      frontend: `// Make sure to replace this with your own Stripe Sandbox publishable key.
const stripe = Stripe('pk_test_...');
const elements = stripe.elements();

const cardElement = elements.create('card', {
  style: {
    base: {
      color: '#32325d',
      fontSize: '16px',
    },
    invalid: {
      color: '#fa755a',
    },
  },
});

cardElement.mount('#card-element');

const form = document.getElementById('payment-form');
const submitButton = document.getElementById('submit');

// Fetch clientSecret on page load
let clientSecret;
fetch('/create-payment-intent', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ amount: 4242, currency: 'usd' }),
})
  .then((res) => res.json())
  .then((data) => { clientSecret = data.clientSecret; });

form.addEventListener('submit', async (e) => {
  e.preventDefault();
  submitButton.disabled = true;

  const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
    payment_method: { card: cardElement },
  });

  if (error) {
    document.getElementById('card-errors').textContent = error.message;
    submitButton.disabled = false;
  } else if (paymentIntent.status === 'succeeded') {
    document.getElementById('payment-message').textContent = 'Payment succeeded!';
  }
});
`,
      server: `// Make sure to replace this with your own Stripe Sandbox secret key.
const stripe = require('stripe')('sk_test_...');
const express = require('express');
const app = express();

app.use(express.json());
app.use(express.static('.'));

app.post('/create-payment-intent', async (req, res) => {
  try {
    const { amount = 4242, currency = 'usd' } = req.body;

    const paymentIntent = await stripe.paymentIntents.create({
      amount,
      currency,
      payment_method_types: ['card'],
    });

    res.json({ clientSecret: paymentIntent.client_secret });
  } catch (error) {
    res.status(400).send({
      error: {
        message: \`\${error.message} - make sure you've replaced sk_test_... in server.js with your secret key from https://dashboard.stripe.com/test/apikeys\`,
      },
    });
  }
});

app.listen(4242, () => console.log('Server running on port ' + (4242)));
`,
      packageJson: `{
  "name": "card-element-js",
  "version": "1.0.0",
  "main": "server.js",
  "scripts": {
    "start": "nodemon server.js"
  },
  "dependencies": {
    "express": "^5.2.1",
    "stripe": "^17.7.0"
  },
  "devDependencies": {
    "nodemon": "^3.1.9"
  }
}
`,
      readme: `# Stripe Card Element Demo

A minimal Express + vanilla JS app that demonstrates Stripe's Card Element.

## Setup

1. Ensure you have a [Node.js installation](https://docs.npmjs.com/downloading-and-installing-node-js-and-npm).
2. Download the project, unzip it, and \`cd\` into the project folder.
3. Open the project in your text editor of choice (e.g. \`code .\`, \`cursor .\`)
4. Create or log into your Stripe sandbox account, then get your API keys from [dashboard.stripe.com/test/apikeys](https://dashboard.stripe.com/test/apikeys).
5. Replace \`sk_test_...\` in \`server.js\` with your Sandbox secret key.
6. Replace \`pk_test_...\` in \`frontend.js\` with your Sandbox publishable key.
7. Install dependencies and start the server: \`npm install && npm start\`
8. Open [http://localhost:4242](http://localhost:4242) in a browser.
`,
    },
  },
  'payment-element': {
    'js': {
      html: `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title>Stripe Payment Element</title>
    <script src="https://js.stripe.com/v3/"></script>
    <link rel="stylesheet" href="styles.css" />
  </head>
  <body>
    <h1>Stripe Payment Element</h1>
    <form id="payment-form">
      <div id="payment-element"></div>
      <div id="payment-message" style="display: none;"></div>
      <button id="submit">Pay now</button>
    </form>
    <script src="frontend.js"></script>
  </body>
</html>
`,
      styles: `body {
  font-family: sans-serif;
  max-width: 600px;
  margin: 60px auto;
  padding: 0 20px;
}

#payment-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#payment-element {
  margin-bottom: 8px;
}

#payment-message {
  color: #df1b41;
  font-size: 14px;
}

button {
  width: 100%;
  padding: 12px;
  background: #635bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}

button:hover {
  background: #5851eb;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
`,
      frontend: `// Make sure to replace this with your own Stripe Sandbox publishable key.
const PUBLISHABLE_KEY = 'pk_test_...';

const stripe = Stripe(PUBLISHABLE_KEY);

let elements;

initialize();

document.querySelector('#payment-form').addEventListener('submit', handleSubmit);

async function initialize() {
  const response = await fetch('/create-payment-intent', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ amount: 2000, currency: 'usd' }),
  });
  const { clientSecret } = await response.json();

  elements = stripe.elements({ clientSecret });

  const paymentElement = elements.create('payment');
  paymentElement.mount('#payment-element');
}

async function handleSubmit(e) {
  e.preventDefault();
  setLoading(true);

  const { error } = await stripe.confirmPayment({
    elements,
    confirmParams: {
      return_url: window.location.origin + '/completion',
    },
  });

  if (error) {
    const messageContainer = document.querySelector('#payment-message');
    messageContainer.textContent = error.message;
    messageContainer.style.display = '';
  }

  setLoading(false);
}

function setLoading(isLoading) {
  const submitButton = document.querySelector('#submit');
  submitButton.disabled = isLoading;
  submitButton.textContent = isLoading ? 'Processing...' : 'Pay now';
}
`,
      server: `// Make sure to replace this with your own Stripe Sandbox secret key.
const stripe = require('stripe')('sk_test_...');
const express = require('express');
const app = express();

app.use(express.json());
app.use(express.static('.'));

app.post('/create-payment-intent', async (req, res) => {
  try {
    const { amount = 2000, currency = 'usd' } = req.body;

    const paymentIntent = await stripe.paymentIntents.create({
      amount,
      currency,
      automatic_payment_methods: { enabled: true },
    });

    res.json({ clientSecret: paymentIntent.client_secret });
  } catch (error) {
    res.status(400).json({
      error: {
        message: \`\${error.message} - make sure you've replaced sk_test_... in server.js with your secret key from https://dashboard.stripe.com/test/apikeys\`,
      },
    });
  }
});

app.listen(4242, () => console.log('Server running on port 4242'));
`,
      packageJson: `{
  "name": "payment-element-js",
  "version": "1.0.0",
  "main": "server.js",
  "scripts": {
    "start": "nodemon server.js"
  },
  "dependencies": {
    "express": "^5.2.1",
    "stripe": "^17.7.0"
  },
  "devDependencies": {
    "nodemon": "^3.1.9"
  }
}
`,
      readme: `# Stripe Payment Element Demo

A minimal Express + vanilla JS app that demonstrates Stripe's Payment Element.

## Setup

1. Ensure you have a [Node.js installation](https://docs.npmjs.com/downloading-and-installing-node-js-and-npm).
2. Download the project, unzip it, and \`cd\` into the project folder.
3. Open the project in your text editor of choice (e.g. \`code .\`, \`cursor .\`)
4. Create or log into your Stripe sandbox account, then get your API keys from [dashboard.stripe.com/test/apikeys](https://dashboard.stripe.com/test/apikeys).
5. Replace \`sk_test_...\` in \`server.js\` with your Sandbox secret key.
6. Replace \`pk_test_...\` in \`frontend.js\` with your Sandbox publishable key.
7. Install dependencies and start the server: \`npm install && npm start\`
8. Open [http://localhost:4242](http://localhost:4242) in a browser.
`,
    },
    'js-deferred': {
      html: `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title>Stripe Payment Element (Deferred)</title>
    <script src="https://js.stripe.com/v3/"></script>
    <link rel="stylesheet" href="styles.css" />
  </head>
  <body>
    <h1>Stripe Payment Element</h1>
    <form id="payment-form">
      <div id="payment-element"></div>
      <div id="payment-message" style="display: none;"></div>
      <button id="submit">Pay now</button>
    </form>
    <script src="frontend.js"></script>
  </body>
</html>
`,
      styles: `body {
  font-family: sans-serif;
  max-width: 600px;
  margin: 60px auto;
  padding: 0 20px;
}

#payment-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#payment-element {
  margin-bottom: 8px;
}

#payment-message {
  color: #df1b41;
  font-size: 14px;
}

button {
  width: 100%;
  padding: 12px;
  background: #635bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}

button:hover {
  background: #5851eb;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
`,
      frontend: `// Make sure to replace this with your own Stripe Sandbox publishable key.
const PUBLISHABLE_KEY = 'pk_test_...';

const stripe = Stripe(PUBLISHABLE_KEY);

const amount = 2000;
const currency = 'usd';

// Initialize Elements with mode/amount/currency — no clientSecret upfront.
const elements = stripe.elements({ mode: 'payment', amount, currency });

const paymentElement = elements.create('payment');
paymentElement.mount('#payment-element');

document.querySelector('#payment-form').addEventListener('submit', handleSubmit);

async function handleSubmit(e) {
  e.preventDefault();
  setLoading(true);

  // Validate fields before creating the PaymentIntent.
  const { error: submitError } = await elements.submit();
  if (submitError) {
    showMessage(submitError.message);
    setLoading(false);
    return;
  }

  // Create the PaymentIntent on the server.
  const response = await fetch('/create-payment-intent', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ amount, currency }),
  });
  const { clientSecret } = await response.json();

  // Confirm the payment using the clientSecret from the server.
  const { error } = await stripe.confirmPayment({
    elements,
    clientSecret,
    confirmParams: {
      return_url: window.location.origin + '/completion',
    },
  });

  if (error) {
    showMessage(error.message);
  }

  setLoading(false);
}

function showMessage(message) {
  const messageContainer = document.querySelector('#payment-message');
  messageContainer.textContent = message;
  messageContainer.style.display = '';
}

function setLoading(isLoading) {
  const submitButton = document.querySelector('#submit');
  submitButton.disabled = isLoading;
  submitButton.textContent = isLoading ? 'Processing...' : 'Pay now';
}
`,
      server: `// Make sure to replace this with your own Stripe Sandbox secret key.
const stripe = require('stripe')('sk_test_...');
const express = require('express');
const app = express();

app.use(express.json());
app.use(express.static('.'));

app.post('/create-payment-intent', async (req, res) => {
  try {
    const { amount = 2000, currency = 'usd' } = req.body;

    const paymentIntent = await stripe.paymentIntents.create({
      amount,
      currency,
      automatic_payment_methods: { enabled: true },
    });

    res.json({ clientSecret: paymentIntent.client_secret });
  } catch (error) {
    res.status(400).json({
      error: {
        message: \`\${error.message} - make sure you've replaced sk_test_... in server.js with your secret key from https://dashboard.stripe.com/test/apikeys\`,
      },
    });
  }
});

app.listen(4242, () => console.log('Server running on port 4242'));
`,
      packageJson: `{
  "name": "payment-element-deferred-js",
  "version": "1.0.0",
  "main": "server.js",
  "scripts": {
    "start": "nodemon server.js"
  },
  "dependencies": {
    "express": "^5.2.1",
    "stripe": "^17.7.0"
  },
  "devDependencies": {
    "nodemon": "^3.1.9"
  }
}
`,
      readme: `# Stripe Payment Element Demo (Deferred)

A minimal Express + vanilla JS app that demonstrates Stripe's Payment Element using deferred PaymentIntent creation. The PaymentIntent is created on the server at confirmation time rather than on page load.

## Setup

1. Ensure you have a [Node.js installation](https://docs.npmjs.com/downloading-and-installing-node-js-and-npm).
2. Download the project, unzip it, and \`cd\` into the project folder.
3. Open the project in your text editor of choice (e.g. \`code .\`, \`cursor .\`)
4. Create or log into your Stripe sandbox account, then get your API keys from [dashboard.stripe.com/test/apikeys](https://dashboard.stripe.com/test/apikeys).
5. Replace \`sk_test_...\` in \`server.js\` with your Sandbox secret key.
6. Replace \`pk_test_...\` in \`frontend.js\` with your Sandbox publishable key.
7. Install dependencies and start the server: \`npm install && npm start\`
8. Open [http://localhost:4242](http://localhost:4242) in a browser.
`,
    },
  },
  'express-checkout': {
    'js': {
      html: `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title>Stripe Express Checkout Element</title>
    <script src="https://js.stripe.com/v3/"></script>
    <link rel="stylesheet" href="styles.css" />
  </head>
  <body>
    <h1>Stripe Express Checkout Element</h1>
    <div id="express-checkout-element"></div>
    <div id="error-message"></div>
    <div id="success-message"></div>
    <script src="frontend.js"></script>
  </body>
</html>
`,
      styles: `body {
  font-family: sans-serif;
  max-width: 600px;
  margin: 60px auto;
  padding: 0 20px;
}

#express-checkout-element {
  margin-bottom: 16px;
}

#error-message {
  color: #df1b41;
  font-size: 14px;
  margin-top: 8px;
}

#success-message {
  color: #30a46c;
  font-size: 14px;
  margin-top: 8px;
}
`,
      frontend: `// Make sure to replace this with your own Stripe Sandbox publishable key.
const PUBLISHABLE_KEY = 'pk_test_...';

const stripe = Stripe(PUBLISHABLE_KEY);

initialize();

async function initialize() {
  const response = await fetch('/create-payment-intent', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ amount: 2000, currency: 'usd' }),
  });
  const { clientSecret } = await response.json();

  const elements = stripe.elements({ clientSecret });

  const expressCheckoutElement = elements.create('expressCheckout');

  expressCheckoutElement.on('confirm', async () => {
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.origin + '/completion',
      },
      redirect: 'if_required',
    });

    if (error) {
      document.querySelector('#error-message').textContent = error.message;
    } else {
      document.querySelector('#success-message').textContent = 'Payment successful!';
    }
  });

  expressCheckoutElement.mount('#express-checkout-element');
}
`,
      server: `// Make sure to replace this with your own Stripe Sandbox secret key.
const stripe = require('stripe')('sk_test_...');
const express = require('express');
const app = express();

app.use(express.json());
app.use(express.static('.'));

app.post('/create-payment-intent', async (req, res) => {
  try {
    const { amount = 2000, currency = 'usd' } = req.body;

    const paymentIntent = await stripe.paymentIntents.create({
      amount,
      currency,
      automatic_payment_methods: { enabled: true },
    });

    res.json({ clientSecret: paymentIntent.client_secret });
  } catch (error) {
    res.status(400).json({
      error: {
        message: \`\${error.message} - make sure you've replaced sk_test_... in server.js with your secret key from https://dashboard.stripe.com/test/apikeys\`,
      },
    });
  }
});

app.listen(4242, () => console.log('Server running on port 4242'));
`,
      packageJson: `{
  "name": "express-checkout-element-js",
  "version": "1.0.0",
  "main": "server.js",
  "scripts": {
    "start": "nodemon server.js"
  },
  "dependencies": {
    "express": "^5.2.1",
    "stripe": "^17.7.0"
  },
  "devDependencies": {
    "nodemon": "^3.1.9"
  }
}
`,
      readme: `# Stripe Express Checkout Element Demo

A minimal Express + vanilla JS app that demonstrates Stripe's Express Checkout Element.

## Setup

1. Ensure you have a [Node.js installation](https://docs.npmjs.com/downloading-and-installing-node-js-and-npm).
2. Download the project, unzip it, and \`cd\` into the project folder.
3. Open the project in your text editor of choice (e.g. \`code .\`, \`cursor .\`)
4. Create or log into your Stripe sandbox account, then get your API keys from [dashboard.stripe.com/test/apikeys](https://dashboard.stripe.com/test/apikeys).
5. Replace \`sk_test_...\` in \`server.js\` with your Sandbox secret key.
6. Replace \`pk_test_...\` in \`frontend.js\` with your Sandbox publishable key.
7. Install dependencies and start the server: \`npm install && npm start\`
8. Open [http://localhost:4242](http://localhost:4242) in a browser.
`,
    },
    'js-deferred': {
      html: `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title>Stripe Express Checkout Element (Deferred)</title>
    <script src="https://js.stripe.com/v3/"></script>
    <link rel="stylesheet" href="styles.css" />
  </head>
  <body>
    <h1>Stripe Express Checkout Element</h1>
    <div id="express-checkout-element"></div>
    <div id="error-message"></div>
    <div id="success-message"></div>
    <script src="frontend.js"></script>
  </body>
</html>
`,
      styles: `body {
  font-family: sans-serif;
  max-width: 600px;
  margin: 60px auto;
  padding: 0 20px;
}

#express-checkout-element {
  margin-bottom: 16px;
}

#error-message {
  color: #df1b41;
  font-size: 14px;
  margin-top: 8px;
}

#success-message {
  color: #30a46c;
  font-size: 14px;
  margin-top: 8px;
}
`,
      frontend: `// Make sure to replace this with your own Stripe Sandbox publishable key.
const PUBLISHABLE_KEY = 'pk_test_...';

const stripe = Stripe(PUBLISHABLE_KEY);

const amount = 2000;
const currency = 'usd';

// Initialize Elements with mode/amount/currency — no clientSecret upfront.
const elements = stripe.elements({ mode: 'payment', amount, currency });

const expressCheckoutElement = elements.create('expressCheckout');

expressCheckoutElement.on('confirm', async () => {
  // Validate fields before creating the PaymentIntent.
  const { error: submitError } = await elements.submit();
  if (submitError) {
    document.querySelector('#error-message').textContent = submitError.message;
    return;
  }

  // Create the PaymentIntent on the server.
  const response = await fetch('/create-payment-intent', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ amount, currency }),
  });
  const { clientSecret } = await response.json();

  // Confirm the payment using the clientSecret from the server.
  const { error } = await stripe.confirmPayment({
    elements,
    clientSecret,
    confirmParams: {
      return_url: window.location.origin + '/completion',
    },
    redirect: 'if_required',
  });

  if (error) {
    document.querySelector('#error-message').textContent = error.message;
  } else {
    document.querySelector('#success-message').textContent = 'Payment successful!';
  }
});

expressCheckoutElement.mount('#express-checkout-element');
`,
      server: `// Make sure to replace this with your own Stripe Sandbox secret key.
const stripe = require('stripe')('sk_test_...');
const express = require('express');
const app = express();

app.use(express.json());
app.use(express.static('.'));

app.post('/create-payment-intent', async (req, res) => {
  try {
    const { amount = 2000, currency = 'usd' } = req.body;

    const paymentIntent = await stripe.paymentIntents.create({
      amount,
      currency,
      automatic_payment_methods: { enabled: true },
    });

    res.json({ clientSecret: paymentIntent.client_secret });
  } catch (error) {
    res.status(400).json({
      error: {
        message: \`\${error.message} - make sure you've replaced sk_test_... in server.js with your secret key from https://dashboard.stripe.com/test/apikeys\`,
      },
    });
  }
});

app.listen(4242, () => console.log('Server running on port 4242'));
`,
      packageJson: `{
  "name": "express-checkout-element-deferred-js",
  "version": "1.0.0",
  "main": "server.js",
  "scripts": {
    "start": "nodemon server.js"
  },
  "dependencies": {
    "express": "^5.2.1",
    "stripe": "^17.7.0"
  },
  "devDependencies": {
    "nodemon": "^3.1.9"
  }
}
`,
      readme: `# Stripe Express Checkout Element Demo (Deferred)

A minimal Express + vanilla JS app that demonstrates Stripe's Express Checkout Element using deferred PaymentIntent creation. The PaymentIntent is created on the server at confirmation time rather than on page load.

## Setup

1. Ensure you have a [Node.js installation](https://docs.npmjs.com/downloading-and-installing-node-js-and-npm).
2. Download the project, unzip it, and \`cd\` into the project folder.
3. Open the project in your text editor of choice (e.g. \`code .\`, \`cursor .\`)
4. Create or log into your Stripe sandbox account, then get your API keys from [dashboard.stripe.com/test/apikeys](https://dashboard.stripe.com/test/apikeys).
5. Replace \`sk_test_...\` in \`server.js\` with your Sandbox secret key.
6. Replace \`pk_test_...\` in \`frontend.js\` with your Sandbox publishable key.
7. Install dependencies and start the server: \`npm install && npm start\`
8. Open [http://localhost:4242](http://localhost:4242) in a browser.
`,
    },
  },
  'checkout-sessions': {
    'js': {
      html: `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title>Stripe Elements + Checkout Sessions</title>
    <script src="https://js.stripe.com/basil/"></script>
    <link rel="stylesheet" href="styles.css" />
  </head>
  <body>
    <h1>Stripe Elements + Checkout Sessions</h1>
    <form id="checkout-form">
      <input type="email" id="email" placeholder="Email" required />
      <div id="payment-element"></div>
      <div id="payment-message"></div>
      <button id="submit" type="button">Pay now</button>
    </form>
    <script src="frontend.js"></script>
  </body>
</html>
`,
      styles: `body {
  font-family: sans-serif;
  max-width: 600px;
  margin: 60px auto;
  padding: 0 20px;
}

#checkout-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#email {
  padding: 10px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 16px;
  outline: none;
}

#email:focus {
  border-color: #635bff;
  box-shadow: 0 0 0 3px rgba(99, 91, 255, 0.15);
}

#payment-element {
  margin-bottom: 8px;
}

#payment-message {
  color: #df1b41;
  font-size: 14px;
}

button {
  width: 100%;
  padding: 12px;
  background: #635bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}

button:hover {
  background: #5851eb;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
`,
      frontend: `// Make sure to replace this with your own Stripe Sandbox publishable key.
const PUBLISHABLE_KEY = 'pk_test_...';

const stripe = Stripe(PUBLISHABLE_KEY);

let checkout;

initialize();

document.querySelector('#submit').addEventListener('click', handleSubmit);

async function initialize() {
  const response = await fetch('/create-checkout-session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ amount: 2000, currency: 'usd' }),
  });
  const { clientSecret } = await response.json();

  checkout = await stripe.initCheckout({ clientSecret });

  const paymentElement = checkout.createPaymentElement({ layout: 'tabs' });
  paymentElement.mount('#payment-element');
}

async function handleSubmit() {
  setLoading(true);

  const email = document.querySelector('#email').value;

  const emailResult = await checkout.updateEmail(email);
  if (emailResult.type === 'error') {
    showMessage(emailResult.error.message);
    setLoading(false);
    return;
  }

  const result = await checkout.confirm();

  if (result.type === 'error') {
    showMessage(result.error.message);
  } else {
    showMessage('Payment successful!');
  }

  setLoading(false);
}

function setLoading(isLoading) {
  const submitButton = document.querySelector('#submit');
  submitButton.disabled = isLoading;
  submitButton.textContent = isLoading ? 'Processing...' : 'Pay now';
}

function showMessage(messageText) {
  const messageContainer = document.querySelector('#payment-message');
  messageContainer.textContent = messageText;
}
`,
      server: `// Make sure to replace this with your own Stripe Sandbox secret key.
const stripe = require('stripe')('sk_test_...');
const express = require('express');
const app = express();

app.use(express.json());
app.use(express.static('.'));

app.post('/create-checkout-session', async (req, res) => {
  try {
    const { amount = 2000, currency = 'usd' } = req.body;

    const session = await stripe.checkout.sessions.create({
      mode: 'payment',
      ui_mode: 'custom',
      line_items: [{
        price_data: {
          currency,
          product_data: { name: 'Potato' },
          unit_amount: amount,
        },
        quantity: 1,
      }],
      return_url: \`http://localhost:4242/?session_id={CHECKOUT_SESSION_ID}\`,
    });

    res.json({ clientSecret: session.client_secret });
  } catch (error) {
    res.status(400).json({
      error: {
        message: \`\${error.message} - make sure you've replaced sk_test_... in server.js with your secret key from https://dashboard.stripe.com/test/apikeys\`,
      },
    });
  }
});

app.listen(4242, () => console.log('Server running on port 4242'));
`,
      packageJson: `{
  "name": "checkout-sessions-js",
  "version": "1.0.0",
  "main": "server.js",
  "scripts": {
    "start": "nodemon server.js"
  },
  "dependencies": {
    "express": "^5.2.1",
    "stripe": "^17.7.0"
  },
  "devDependencies": {
    "nodemon": "^3.1.9"
  }
}
`,
      readme: `# Stripe Elements + Checkout Sessions Demo

A minimal Express + vanilla JS app that demonstrates Stripe's Elements with the Checkout Sessions API (\`ui_mode: 'custom'\`).

## Setup

1. Ensure you have a [Node.js installation](https://docs.npmjs.com/downloading-and-installing-node-js-and-npm).
2. Download the project, unzip it, and \`cd\` into the project folder.
3. Open the project in your text editor of choice (e.g. \`code .\`, \`cursor .\`)
4. Create or log into your Stripe sandbox account, then get your API keys from [dashboard.stripe.com/test/apikeys](https://dashboard.stripe.com/test/apikeys).
5. Replace \`sk_test_...\` in \`server.js\` with your Sandbox secret key.
6. Replace \`pk_test_...\` in \`frontend.js\` with your Sandbox publishable key.
7. Install dependencies and start the server: \`npm install && npm start\`
8. Open [http://localhost:4242](http://localhost:4242) in a browser.
`,
    },
  },
  'payment-request-button': {
    'js': {
      html: `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title>Stripe Payment Request Button</title>
    <script src="https://js.stripe.com/v3/"></script>
    <link rel="stylesheet" href="styles.css" />
  </head>
  <body>
    <h1>Stripe Payment Request Button</h1>
    <div id="payment-request-button"></div>
    <div id="error-message"></div>
    <div id="success-message"></div>
    <script src="frontend.js"></script>
  </body>
</html>
`,
      styles: `body {
  font-family: sans-serif;
  max-width: 500px;
  margin: 60px auto;
  padding: 0 20px;
}

h1 {
  margin-bottom: 24px;
}

#payment-request-button {
  margin-bottom: 16px;
}

#error-message {
  color: #df1b41;
  font-size: 14px;
  margin-top: 12px;
}

#success-message {
  color: #30a652;
  font-size: 14px;
  margin-top: 12px;
}
`,
      frontend: `// Make sure to replace this with your own Stripe Sandbox publishable key.
const stripe = Stripe('pk_test_...');

initialize();

async function initialize() {
  const response = await fetch('/create-payment-intent', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ amount: 4242, currency: 'usd' }),
  });
  const { clientSecret } = await response.json();

  const paymentRequest = stripe.paymentRequest({
    country: 'US',
    currency: 'usd',
    total: {
      label: 'Demo total',
      amount: 4242,
    },
    requestPayerName: true,
    requestPayerEmail: true,
  });

  const elements = stripe.elements();
  const prButton = elements.create('paymentRequestButton', { paymentRequest });

  paymentRequest.canMakePayment().then((result) => {
    if (result) {
      prButton.mount('#payment-request-button');
    } else {
      document.getElementById('payment-request-button').style.display = 'none';
    }
  });

  paymentRequest.on('paymentmethod', async (ev) => {
    const { error: confirmError } = await stripe.confirmCardPayment(
      clientSecret,
      { payment_method: ev.paymentMethod.id },
      { handleActions: false }
    );

    if (confirmError) {
      ev.complete('fail');
      document.getElementById('error-message').textContent = confirmError.message;
    } else {
      ev.complete('success');
      document.getElementById('success-message').textContent = 'Payment succeeded!';
    }
  });
}
`,
      server: `// Make sure to replace this with your own Stripe Sandbox secret key.
const stripe = require('stripe')('sk_test_...');
const express = require('express');
const app = express();

app.use(express.json());
app.use(express.static('.'));

app.post('/create-payment-intent', async (req, res) => {
  try {
    const { amount = 4242, currency = 'usd' } = req.body;

    const paymentIntent = await stripe.paymentIntents.create({
      amount,
      currency,
      payment_method_types: ['card'],
    });

    res.json({ clientSecret: paymentIntent.client_secret });
  } catch (error) {
    res.status(400).send({
      error: {
        message: \`\${error.message} - make sure you've replaced sk_test_... in server.js with your secret key from https://dashboard.stripe.com/test/apikeys\`,
      },
    });
  }
});

app.listen(4242, () => console.log('Server running on port ' + (4242)));
`,
      packageJson: `{
  "name": "payment-request-button-js",
  "version": "1.0.0",
  "main": "server.js",
  "scripts": {
    "start": "nodemon server.js"
  },
  "dependencies": {
    "express": "^5.2.1",
    "stripe": "^17.7.0"
  },
  "devDependencies": {
    "nodemon": "^3.1.9"
  }
}
`,
      readme: `# Stripe Payment Request Button Demo

A minimal Express + vanilla JS app that demonstrates Stripe's Payment Request Button (Apple Pay, Google Pay, etc.).

## Setup

1. Ensure you have a [Node.js installation](https://docs.npmjs.com/downloading-and-installing-node-js-and-npm).
2. Download the project, unzip it, and \`cd\` into the project folder.
3. Open the project in your text editor of choice (e.g. \`code .\`, \`cursor .\`)
4. Create or log into your Stripe sandbox account, then get your API keys from [dashboard.stripe.com/test/apikeys](https://dashboard.stripe.com/test/apikeys).
5. Replace \`sk_test_...\` in \`server.js\` with your Sandbox secret key.
6. Replace \`pk_test_...\` in \`frontend.js\` with your Sandbox publishable key.
7. Install dependencies and start the server: \`npm install && npm start\`
8. Open [http://localhost:4242](http://localhost:4242) in a browser.
`,
    },
  },
  'embedded-checkout': {
    'js': {
      html: `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title>Stripe Embedded Checkout</title>
    <script src="https://js.stripe.com/v3/"></script>
    <link rel="stylesheet" href="styles.css" />
  </head>
  <body>
    <h1>Stripe Embedded Checkout</h1>
    <div id="checkout"></div>
    <script src="frontend.js"></script>
  </body>
</html>
`,
      styles: `body {
  font-family: sans-serif;
  max-width: 800px;
  margin: 60px auto;
  padding: 0 20px;
}

h1 {
  margin-bottom: 24px;
}

#checkout {
  min-height: 300px;
}
`,
      frontend: `// Make sure to replace this with your own Stripe Sandbox publishable key.
const stripe = Stripe('pk_test_...');

async function initCheckout() {
  const res = await fetch('/create-checkout-session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ amount: 4242, currency: 'usd' }),
  });
  const { clientSecret } = await res.json();

  const checkout = await stripe.initEmbeddedCheckout({ clientSecret });
  checkout.mount('#checkout');
}

initCheckout();
`,
      server: `// Make sure to replace this with your own Stripe Sandbox secret key.
const stripe = require('stripe')('sk_test_...');
const express = require('express');
const app = express();

app.use(express.json());
app.use(express.static('.'));

app.post('/create-checkout-session', async (req, res) => {
  try {
    const { amount = 4242, currency = 'usd' } = req.body;

    const session = await stripe.checkout.sessions.create({
      mode: 'payment',
      ui_mode: 'embedded',
      return_url: \`http://localhost:4242/return.html?session_id={CHECKOUT_SESSION_ID}\`,
      line_items: [{
        price_data: {
          currency,
          product_data: { name: 'Potato', images: ['https://stripe.erintaylor.dev/potato.png'] },
          unit_amount: amount,
        },
        quantity: 1,
      }],
    });

    res.json({ clientSecret: session.client_secret });
  } catch (error) {
    res.status(400).send({
      error: {
        message: \`\${error.message} - make sure you've replaced sk_test_... in server.js with your secret key from https://dashboard.stripe.com/test/apikeys\`,
      },
    });
  }
});

app.listen(4242, () => console.log('Server running on port ' + (4242)));
`,
      packageJson: `{
  "name": "embedded-checkout-js",
  "version": "1.0.0",
  "main": "server.js",
  "scripts": {
    "start": "nodemon server.js"
  },
  "dependencies": {
    "express": "^5.2.1",
    "stripe": "^17.7.0"
  },
  "devDependencies": {
    "nodemon": "^3.1.9"
  }
}
`,
      readme: `# Stripe Embedded Checkout Demo

A minimal Express + vanilla JS app that demonstrates Stripe's Embedded Checkout (\`ui_mode: 'embedded'\`).

## Setup

1. Ensure you have a [Node.js installation](https://docs.npmjs.com/downloading-and-installing-node-js-and-npm).
2. Download the project, unzip it, and \`cd\` into the project folder.
3. Open the project in your text editor of choice (e.g. \`code .\`, \`cursor .\`)
4. Create or log into your Stripe sandbox account, then get your API keys from [dashboard.stripe.com/test/apikeys](https://dashboard.stripe.com/test/apikeys).
5. Replace \`sk_test_...\` in \`server.js\` with your Sandbox secret key.
6. Replace \`pk_test_...\` in \`frontend.js\` with your Sandbox publishable key.
7. Install dependencies and start the server: \`npm install && npm start\`
8. Open [http://localhost:4242](http://localhost:4242) in a browser.
`,
    },
  },
  'terminal': {
    'js': {
      html: `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title>Stripe Terminal (Server-Driven)</title>
    <link rel="stylesheet" href="styles.css" />
  </head>
  <body>
    <h1>Stripe Terminal (Server-Driven)</h1>

    <div>
      <button id="btn-create-reader">Create Simulated Reader</button>
    </div>
    <div>
      <button id="btn-create-pi" disabled>Create Payment Intent ($42.42)</button>
    </div>
    <div>
      <button id="btn-process" disabled>Process Payment Intent</button>
    </div>
    <div>
      <button id="btn-simulate" disabled>Simulate Card Tap</button>
      <button id="btn-cancel" disabled>Cancel</button>
    </div>
    <div>
      <button id="btn-capture" disabled>Capture Payment</button>
    </div>
    <div>
      <button id="btn-reset" disabled>Reset</button>
    </div>

    <div id="log"></div>

    <script src="frontend.js"></script>
  </body>
</html>
`,
      styles: `body {
  font-family: sans-serif;
  max-width: 600px;
  margin: 60px auto;
  padding: 0 20px;
}

h1 {
  margin-bottom: 24px;
}

div {
  margin-bottom: 8px;
}

button {
  margin-right: 8px;
  padding: 8px 16px;
  cursor: pointer;
  background: #635bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
}

button:hover:not(:disabled) {
  background: #5851eb;
}

button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

#log {
  margin-top: 16px;
  background: #f5f5f5;
  padding: 12px;
  font-family: monospace;
  font-size: 13px;
  white-space: pre;
  border-radius: 4px;
  min-height: 60px;
}
`,
      frontend: `let readerId = null;
let paymentIntentId = null;
let pollInterval = null;

const btn = {
  createReader: document.getElementById('btn-create-reader'),
  createPi:     document.getElementById('btn-create-pi'),
  process:      document.getElementById('btn-process'),
  simulate:     document.getElementById('btn-simulate'),
  cancel:       document.getElementById('btn-cancel'),
  capture:      document.getElementById('btn-capture'),
  reset:        document.getElementById('btn-reset'),
};

btn.createReader.addEventListener('click', createReader);
btn.createPi.addEventListener('click', createPaymentIntent);
btn.process.addEventListener('click', processPaymentIntent);
btn.simulate.addEventListener('click', simulateTap);
btn.cancel.addEventListener('click', cancelReaderAction);
btn.capture.addEventListener('click', capturePayment);
btn.reset.addEventListener('click', reset);

function log(msg) {
  const el = document.getElementById('log');
  el.textContent += msg + '\\n';
}

function post(endpoint, body) {
  return fetch(\`/\${endpoint}\`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).then(r => r.json());
}

function stopPolling() {
  if (pollInterval) {
    clearInterval(pollInterval);
    pollInterval = null;
  }
}

async function createReader() {
  btn.createReader.disabled = true;
  const data = await post('create-reader', { country: 'US' });
  readerId = data.readerId;
  log('Reader created: ' + readerId);
  btn.createPi.disabled = false;
  btn.reset.disabled = false;
}

async function createPaymentIntent() {
  btn.createPi.disabled = true;
  const data = await post('create-payment-intent', { amount: 4242, currency: 'usd' });
  paymentIntentId = data.paymentIntentId;
  log('Payment intent created: ' + paymentIntentId);
  btn.process.disabled = false;
}

async function processPaymentIntent() {
  btn.process.disabled = true;
  await post('process-payment-intent', { readerId, paymentIntentId });
  log('Sent to reader — waiting for card...');
  btn.simulate.disabled = false;
  btn.cancel.disabled = false;
}

async function simulateTap() {
  btn.simulate.disabled = true;
  btn.cancel.disabled = true;
  await post('simulate-tap', { readerId });
  log('Card tapped — polling for authorization...');

  pollInterval = setInterval(async () => {
    const data = await post('reader-status', { readerId });
    if (data.actionStatus === 'succeeded') {
      stopPolling();
      log('Payment authorized — ready to capture');
      btn.capture.disabled = false;
    } else if (data.actionStatus === 'failed') {
      stopPolling();
      log('Authorization failed');
      btn.reset.disabled = false;
    }
  }, 1500);
}

async function cancelReaderAction() {
  btn.simulate.disabled = true;
  btn.cancel.disabled = true;
  await post('cancel-reader-action', { readerId });
  log('Reader action cancelled');
  paymentIntentId = null;
  btn.createPi.disabled = false;
}

async function capturePayment() {
  btn.capture.disabled = true;
  const data = await post('capture-payment-intent', { paymentIntentId });
  log('Payment captured: ' + data.paymentIntent.id + ' (' + data.paymentIntent.status + ')');
}

function reset() {
  stopPolling();
  paymentIntentId = null;
  btn.createPi.disabled = readerId ? false : true;
  btn.process.disabled = true;
  btn.simulate.disabled = true;
  btn.cancel.disabled = true;
  btn.capture.disabled = true;
  log('--- reset ---');
}
`,
      server: `// Make sure to replace this with your own Stripe Sandbox secret key.
const stripe = require('stripe')('sk_test_...');
const express = require('express');
const app = express();

app.use(express.json());
app.use(express.static('.'));

// Create a simulated Terminal reader
app.post('/create-reader', async (req, res) => {
  try {
    const reader = await stripe.terminal.readers.create({
      registration_code: 'simulated-wpe',
      label: 'Simulated Reader',
    });
    res.json({ readerId: reader.id, readerLabel: reader.label });
  } catch (error) {
    res.status(400).json({ error: error.message });
  }
});

// Create a payment intent for in-person capture
app.post('/create-payment-intent', async (req, res) => {
  try {
    const { amount = 4242, currency = 'usd' } = req.body;
    const paymentIntent = await stripe.paymentIntents.create({
      amount,
      currency,
      payment_method_types: ['card_present'],
      capture_method: 'manual',
    });
    res.json({ paymentIntentId: paymentIntent.id });
  } catch (error) {
    res.status(400).json({ error: error.message });
  }
});

// Send payment intent to the reader
app.post('/process-payment-intent', async (req, res) => {
  try {
    const { readerId, paymentIntentId } = req.body;
    const reader = await stripe.terminal.readers.processPaymentIntent(readerId, {
      payment_intent: paymentIntentId,
    });
    res.json({ reader });
  } catch (error) {
    res.status(400).json({ error: error.message });
  }
});

// Cancel the current reader action
app.post('/cancel-reader-action', async (req, res) => {
  try {
    const { readerId } = req.body;
    const reader = await stripe.terminal.readers.cancelAction(readerId);
    res.json({ reader });
  } catch (error) {
    res.status(400).json({ error: error.message });
  }
});

// Simulate a card tap (test mode only)
app.post('/simulate-tap', async (req, res) => {
  try {
    const { readerId } = req.body;
    const reader = await stripe.testHelpers.terminal.readers.presentPaymentMethod(readerId);
    res.json({ reader });
  } catch (error) {
    res.status(400).json({ error: error.message });
  }
});

// Poll reader status
app.post('/reader-status', async (req, res) => {
  try {
    const { readerId } = req.body;
    const reader = await stripe.terminal.readers.retrieve(readerId);
    res.json({ actionStatus: reader.action?.status });
  } catch (error) {
    res.status(400).json({ error: error.message });
  }
});

// Capture the authorized payment
app.post('/capture-payment-intent', async (req, res) => {
  try {
    const { paymentIntentId } = req.body;
    const paymentIntent = await stripe.paymentIntents.capture(paymentIntentId);
    res.json({ paymentIntent });
  } catch (error) {
    res.status(400).json({ error: error.message });
  }
});

app.listen(4242, () => console.log('Server running on port ' + (4242)));
`,
      packageJson: `{
  "name": "terminal-server-driven-js",
  "version": "1.0.0",
  "main": "server.js",
  "scripts": {
    "start": "nodemon server.js"
  },
  "dependencies": {
    "express": "^5.2.1",
    "stripe": "^17.7.0"
  },
  "devDependencies": {
    "nodemon": "^3.1.9"
  }
}
`,
      readme: `# Stripe Terminal (Server-Driven) Demo

A minimal Express + vanilla JS app that demonstrates Stripe Terminal's server-driven integration.

## Setup

1. Ensure you have a [Node.js installation](https://docs.npmjs.com/downloading-and-installing-node-js-and-npm).
2. Download the project, unzip it, and \`cd\` into the project folder.
3. Open the project in your text editor of choice (e.g. \`code .\`, \`cursor .\`)
4. Create or log into your Stripe sandbox account, then get your API keys from [dashboard.stripe.com/test/apikeys](https://dashboard.stripe.com/test/apikeys).
5. Replace \`sk_test_...\` in \`server.js\` with your Sandbox secret key.
6. Install dependencies and start the server: \`npm install && npm start\`
7. Open [http://localhost:4242](http://localhost:4242) in a browser.
8. Click "Create Simulated Reader" to begin the payment flow.
`,
    },
  },
  'terminal-js-sdk': {
    'js': {
      html: `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title>Stripe Terminal (JavaScript SDK)</title>
    <script src="https://js.stripe.com/terminal/v1/"></script>
    <link rel="stylesheet" href="styles.css" />
  </head>
  <body>
    <h1>Stripe Terminal (JavaScript SDK)</h1>

    <div>
      <button id="btn-connect">Connect to Simulated Reader</button>
    </div>
    <div>
      <button id="btn-create-pi" disabled>Create Payment Intent ($42.42)</button>
    </div>
    <div>
      <button id="btn-collect" disabled>Collect Payment Method</button>
      <button id="btn-cancel-collect" disabled>Cancel</button>
    </div>
    <div>
      <button id="btn-process" disabled>Process Payment</button>
    </div>
    <div>
      <button id="btn-capture" disabled>Capture Payment</button>
    </div>
    <div>
      <button id="btn-reset" disabled>Reset</button>
    </div>

    <div id="log"></div>

    <script src="frontend.js"></script>
  </body>
</html>
`,
      styles: `body {
  font-family: sans-serif;
  max-width: 600px;
  margin: 60px auto;
  padding: 0 20px;
}

h1 {
  margin-bottom: 24px;
}

div {
  margin-bottom: 8px;
}

button {
  margin-right: 8px;
  padding: 8px 16px;
  cursor: pointer;
  background: #635bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
}

button:hover:not(:disabled) {
  background: #5851eb;
}

button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

#log {
  margin-top: 16px;
  background: #f5f5f5;
  padding: 12px;
  font-family: monospace;
  font-size: 13px;
  white-space: pre;
  border-radius: 4px;
  min-height: 60px;
}
`,
      frontend: `// StripeTerminal is loaded from the CDN script tag in index.html

let terminal = null;
let paymentIntent = null;

const btn = {
  connect:       document.getElementById('btn-connect'),
  createPi:      document.getElementById('btn-create-pi'),
  collect:       document.getElementById('btn-collect'),
  cancelCollect: document.getElementById('btn-cancel-collect'),
  process:       document.getElementById('btn-process'),
  capture:       document.getElementById('btn-capture'),
  reset:         document.getElementById('btn-reset'),
};

btn.connect.addEventListener('click', connect);
btn.createPi.addEventListener('click', createPaymentIntent);
btn.collect.addEventListener('click', collectPaymentMethod);
btn.cancelCollect.addEventListener('click', cancelCollect);
btn.process.addEventListener('click', processPayment);
btn.capture.addEventListener('click', capturePayment);
btn.reset.addEventListener('click', reset);

function log(msg) {
  const el = document.getElementById('log');
  el.textContent += msg + '\\n';
}

function post(endpoint, body = {}) {
  return fetch(\`/\${endpoint}\`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).then(r => r.json());
}

async function connect() {
  btn.connect.disabled = true;

  terminal = StripeTerminal.create({
    onFetchConnectionToken: async () => {
      const data = await post('connection-token');
      return data.secret;
    },
    onUnexpectedReaderDisconnect: () => log('Reader disconnected unexpectedly'),
  });

  const { discoveredReaders, error: discoverError } = await terminal.discoverReaders({ simulated: true });
  if (discoverError) { log('Discover error: ' + discoverError.message); return; }
  log('Found ' + discoveredReaders.length + ' reader(s)');

  const { reader, error: connectError } = await terminal.connectReader(discoveredReaders[0]);
  if (connectError) { log('Connect error: ' + connectError.message); return; }
  log('Connected: ' + reader.id);

  btn.createPi.disabled = false;
  btn.reset.disabled = false;
}

async function createPaymentIntent() {
  btn.createPi.disabled = true;
  const data = await post('create-payment-intent', { amount: 4242, currency: 'usd' });
  paymentIntent = { id: data.paymentIntentId, client_secret: data.clientSecret };
  log('Payment intent created: ' + paymentIntent.id);
  btn.collect.disabled = false;
}

async function collectPaymentMethod() {
  btn.collect.disabled = true;
  btn.cancelCollect.disabled = false;

  const { paymentIntent: pi, error } = await terminal.collectPaymentMethod(paymentIntent.client_secret);
  btn.cancelCollect.disabled = true;

  if (error) {
    log('Collect error: ' + error.message);
    btn.collect.disabled = false;
    return;
  }

  paymentIntent = pi;
  log('Card collected — ready to process');
  btn.process.disabled = false;
}

async function cancelCollect() {
  btn.cancelCollect.disabled = true;
  const { error } = await terminal.cancelCollectPaymentMethod();
  if (error) { log('Cancel error: ' + error.message); return; }
  log('Collection cancelled');
  btn.collect.disabled = false;
}

async function processPayment() {
  btn.process.disabled = true;
  const { paymentIntent: pi, error } = await terminal.processPayment(paymentIntent);
  if (error) {
    log('Process error: ' + error.message);
    return;
  }
  paymentIntent = pi;
  log('Payment authorized — ready to capture');
  btn.capture.disabled = false;
}

async function capturePayment() {
  btn.capture.disabled = true;
  const data = await post('capture-payment-intent', { paymentIntentId: paymentIntent.id });
  log('Payment captured: ' + data.paymentIntent.id + ' (' + data.paymentIntent.status + ')');
}

function reset() {
  paymentIntent = null;
  btn.createPi.disabled = terminal ? false : true;
  btn.collect.disabled = true;
  btn.cancelCollect.disabled = true;
  btn.process.disabled = true;
  btn.capture.disabled = true;
  log('--- reset ---');
}
`,
      server: `// Make sure to replace this with your own Stripe Sandbox secret key.
const stripe = require('stripe')('sk_test_...');
const express = require('express');
const app = express();

app.use(express.json());
app.use(express.static('.'));

// Create a connection token for the Terminal JS SDK
app.post('/connection-token', async (req, res) => {
  try {
    const token = await stripe.terminal.connectionTokens.create();
    res.json({ secret: token.secret });
  } catch (error) {
    res.status(400).json({ error: error.message });
  }
});

// Create a payment intent for in-person capture
app.post('/create-payment-intent', async (req, res) => {
  try {
    const { amount = 4242, currency = 'usd' } = req.body;
    const paymentIntent = await stripe.paymentIntents.create({
      amount,
      currency,
      payment_method_types: ['card_present'],
      capture_method: 'manual',
    });
    res.json({ paymentIntentId: paymentIntent.id, clientSecret: paymentIntent.client_secret });
  } catch (error) {
    res.status(400).json({ error: error.message });
  }
});

// Capture the authorized payment
app.post('/capture-payment-intent', async (req, res) => {
  try {
    const { paymentIntentId } = req.body;
    const paymentIntent = await stripe.paymentIntents.capture(paymentIntentId);
    res.json({ paymentIntent });
  } catch (error) {
    res.status(400).json({ error: error.message });
  }
});

app.listen(4242, () => console.log('Server running on port ' + (4242)));
`,
      packageJson: `{
  "name": "terminal-js-sdk-js",
  "version": "1.0.0",
  "main": "server.js",
  "scripts": {
    "start": "nodemon server.js"
  },
  "dependencies": {
    "express": "^5.2.1",
    "stripe": "^17.7.0"
  },
  "devDependencies": {
    "nodemon": "^3.1.9"
  }
}
`,
      readme: `# Stripe Terminal (JavaScript SDK) Demo

A minimal Express + vanilla JS app that demonstrates Stripe Terminal's JavaScript SDK integration.

## Setup

1. Ensure you have a [Node.js installation](https://docs.npmjs.com/downloading-and-installing-node-js-and-npm).
2. Download the project, unzip it, and \`cd\` into the project folder.
3. Open the project in your text editor of choice (e.g. \`code .\`, \`cursor .\`)
4. Create or log into your Stripe sandbox account, then get your API keys from [dashboard.stripe.com/test/apikeys](https://dashboard.stripe.com/test/apikeys).
5. Replace \`sk_test_...\` in \`server.js\` with your Sandbox secret key.
6. Install dependencies and start the server: \`npm install && npm start\`
7. Open [http://localhost:4242](http://localhost:4242) in a browser.
8. Click "Connect to Simulated Reader" to begin the payment flow.
`,
    },
  },
  'connect-embedded': {
    'js': {
      html: `<!DOCTYPE html>
<html>
  <head>
    <title>Stripe Connect Embedded Components</title>
    <link rel="stylesheet" href="styles.css">
    <script src="https://connect-js.stripe.com/v1.0/connect.js"></script>
    <script src="frontend.js"></script>
  </head>
  <body>
    <h1>Stripe Connect Embedded Components</h1>
    <div>Account ID: <span id="account-result-container">loading...</span></div>
    <div id="error-container" style="display: none"></div>
    <div id="component-selector-container" style="display: none">
      <label for="component-selector">Select Component:</label>
      <select id="component-selector">
        <option value="account-onboarding">Account Onboarding</option>
        <option value="account-management">Account Management</option>
        <option value="payments">Payments</option>
        <option value="payouts">Payouts</option>
        <option value="balances">Balances</option>
        <option value="notification-banner">Notification Banner</option>
        <option value="documents">Documents</option>
        <option value="tax-registrations">Tax Registrations</option>
        <option value="tax-settings">Tax Settings</option>
      </select>
      <div id="connect-container"></div>
    </div>
  </body>
</html>
`,
      styles: `body {
  font-family: sans-serif;
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;
}

#error-container {
  color: red;
  margin: 10px 0;
}
`,
      frontend: `// Make sure to replace this with your own Stripe Sandbox publishable key.
const PUBLISHABLE_KEY = 'pk_test_...';

//////////////
// Main
//////////////

async function main() {

  // Get DOM elements
  const accountIdOutput = document.getElementById('account-result-container');
  const componentSelectorPanel = document.getElementById('component-selector-container');
  const componentDropdown = document.getElementById('component-selector');
  const connectContainer = document.getElementById('connect-container');
  const errorContainer = document.getElementById('error-container');

  // Create a connected account and display the account ID
  let accountId;

  try {
    accountId = await createConnectedAccount();
    accountIdOutput.textContent = accountId;
    componentSelectorPanel.style.display = '';
  } catch (err) {
    accountIdOutput.textContent = '';
    errorContainer.style.display = '';
    errorContainer.textContent = err.message;
    return;
  }

  // Initialize Connect.js
  const connect = StripeConnect.init({
    publishableKey: PUBLISHABLE_KEY,
    fetchClientSecret: () => fetchAccountSessionClientSecret(accountId),
  });

  const onLoadError = (loadError) => {
    errorContainer.style.display = '';
    errorContainer.textContent = \`\${loadError.error.message} - make sure you've replaced pk_test_... in frontend.js with your publishable key from https://dashboard.stripe.com/test/apikeys\`;
  };

  // Mount the account onboarding component
  mountEmbeddedComponent(connect, 'account-onboarding', connectContainer, onLoadError);

  // Add event listener to the component dropdown
  componentDropdown.addEventListener('change', (event) => {
    mountEmbeddedComponent(connect, event.target.value, connectContainer, onLoadError);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  main();
});


//////////////
// API calls
//////////////

// Creates a connected account
async function createConnectedAccount() {
  const url = '/create-connected-account';
  const response = await fetch(url, {
    method: 'POST',
  });
  const body = await response.json();
  if (!response.ok) {
    const message = body.error?.message || \`\${response.status} \${response.statusText}\`;
    console.error('Backend error', { url, status: response.status, message });
    throw new Error(message);
  }
  const { accountId } = body;
  return accountId;
}

// Fetches a client secret (server enables every demo component in one Account Session).
async function fetchAccountSessionClientSecret(accountId) {
  const url = '/create-account-session';
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ accountId }),
  });
  const body = await response.json();
  if (!response.ok) {
    const message = body.error?.message || \`\${response.status} \${response.statusText}\`;
    console.error('Backend error', { url, status: response.status, message });
    throw new Error(message);
  }
  const { clientSecret } = body;
  return clientSecret;
}

//////////////
// Utilities
//////////////

// Creates and mounts an embedded component
async function mountEmbeddedComponent(connect, componentTag, mountElement, onLoadError) {
  mountElement.replaceChildren();
  try {
    const component = connect.create(componentTag);
    if (onLoadError) {
      component.setOnLoadError(onLoadError);
    }
    mountElement.appendChild(component);
  } catch (err) {
    console.error(err);
    mountElement.textContent = err.message;
  }
}
`,
      server: `// Make sure to replace this with your own Stripe Sandbox secret key.
const stripe = require('stripe')('sk_test_...');
const express = require('express');
const app = express();

app.use(express.json());
app.use(express.static('.'));

// Enable every embedded component we're showing in the demo
const DEMO_ACCOUNT_SESSION_COMPONENTS = {
  account_onboarding: { enabled: true },
  account_management: { enabled: true },
  payments: { enabled: true },
  payouts: { enabled: true },
  balances: { enabled: true },
  notification_banner: { enabled: true },
  documents: { enabled: true },
  tax_registrations: { enabled: true },
  tax_settings: { enabled: true },
};

// Create a connected account
app.post('/create-connected-account', async (req, res) => {
  try {
    const account = await stripe.accounts.create({
      type: 'express',
      capabilities: {
        card_payments: { requested: true },
        transfers: { requested: true },
      },
    });

    res.json({
      accountId: account.id,
    });
  } catch (error) {
    res.status(400).send({
      error: {
        message: \`\${error.message} - make sure you've replaced sk_test_... in server.js with your secret key from https://dashboard.stripe.com/test/apikeys\`,
      },
    });
  }
});

// Fetch a client secret for the demo account session
app.post('/create-account-session', async (req, res) => {
  try {
    const { accountId } = req.body;

    const accountSession = await stripe.accountSessions.create({
      account: accountId,
      components: DEMO_ACCOUNT_SESSION_COMPONENTS,
    });

    res.json({
      clientSecret: accountSession.client_secret,
    });

  } catch (error) {
    res.status(400).send({
      error: {
        message: \`\${error.message} - make sure you've replaced sk_test_... in server.js with your secret key from https://dashboard.stripe.com/test/apikeys\`,
      },
    });
  }
});

app.listen(4242, () => console.log('Server running on port ' + (4242)));
`,
      packageJson: `{
  "name": "connect-embedded-js",
  "version": "1.0.0",
  "main": "server.js",
  "scripts": {
    "start": "nodemon server.js"
  },
  "dependencies": {
    "express": "^5.2.1",
    "stripe": "^20.4.1"
  },
  "devDependencies": {
    "nodemon": "^3.1.9"
  }
}
`,
      readme: `# Stripe Connect Embedded Components Demo

A minimal Express + vanilla JS app that demonstrates Stripe Connect Embedded Components.

## Setup

1. Ensure you have a [Node.js installation](https://docs.npmjs.com/downloading-and-installing-node-js-and-npm).
2. Download the project, unzip it, and \`cd\` into the project folder.
3. Open the project in your text editor of choice (e.g. \`code .\`, \`cursor .\`)
4. Create or log into your Stripe sandbox account, then get your API keys from https://dashboard.stripe.com/test/apikeys.
5. Replace \`sk_test_...\` in \`server.js\` and \`pk_test_...\` in \`frontend.js\` with their respective Sandbox keys from the dashboard.
6. Install dependencies and start the server: \`npm install && npm start\`
7. Open http://localhost:4242 in a browser
`,
    },
  },
  'hosted-checkout': {
    'js': {
      html: `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title>Stripe Hosted Checkout</title>
    <link rel="stylesheet" href="styles.css" />
  </head>
  <body>
    <h1>Stripe Hosted Checkout</h1>
    <p>Click below to be redirected to Stripe's hosted checkout page.</p>
    <div id="product">
      <span id="product-name">Potato</span>
      <span id="product-price">$20.00</span>
    </div>
    <button id="checkout-button">Checkout</button>
    <div id="error-container" style="display: none;"></div>
    <script src="frontend.js"></script>
  </body>
</html>
`,
      styles: `body {
  font-family: sans-serif;
  max-width: 600px;
  margin: 60px auto;
  padding: 0 20px;
}

#product {
  display: flex;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 20px;
}

button {
  width: 100%;
  padding: 12px;
  background: #635bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}

button:hover {
  background: #5851eb;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

#error-container {
  color: #df1b41;
  margin-top: 12px;
  font-size: 14px;
}
`,
      frontend: `// Make sure to replace this with your own Stripe Sandbox publishable key.
const PUBLISHABLE_KEY = 'pk_test_...';

document.addEventListener('DOMContentLoaded', () => {
  const button = document.getElementById('checkout-button');
  const errorContainer = document.getElementById('error-container');

  button.addEventListener('click', async () => {
    button.disabled = true;
    button.textContent = 'Redirecting...';
    errorContainer.style.display = 'none';

    try {
      const response = await fetch('/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: 2000, currency: 'usd' }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error?.message || 'Failed to create checkout session');
      }

      window.location.href = data.url;
    } catch (err) {
      errorContainer.textContent = err.message;
      errorContainer.style.display = '';
      button.disabled = false;
      button.textContent = 'Checkout';
    }
  });
});
`,
      server: `// Make sure to replace this with your own Stripe Sandbox secret key.
const stripe = require('stripe')('sk_test_...');
const express = require('express');
const app = express();

app.use(express.json());
app.use(express.static('.'));

app.post('/create-checkout-session', async (req, res) => {
  try {
    const { amount = 2000, currency = 'usd' } = req.body;

    const session = await stripe.checkout.sessions.create({
      mode: 'payment',
      ui_mode: 'hosted',
      success_url: 'http://localhost:4242/success.html?session_id={CHECKOUT_SESSION_ID}',
      cancel_url: 'http://localhost:4242/',
      line_items: [{
        price_data: {
          currency,
          product_data: { name: 'Potato', images: ['https://stripe.erintaylor.dev/potato.png'] },
          unit_amount: amount,
        },
        quantity: 1,
      }],
    });

    res.json({ url: session.url });
  } catch (error) {
    res.status(400).send({
      error: {
        message: \`\${error.message} - make sure you've replaced sk_test_... in server.js with your secret key from https://dashboard.stripe.com/test/apikeys\`,
      },
    });
  }
});

app.listen(4242, () => console.log('Server running on port ' + (4242)));
`,
      packageJson: `{
  "name": "hosted-checkout-js",
  "version": "1.0.0",
  "main": "server.js",
  "scripts": {
    "start": "nodemon server.js"
  },
  "dependencies": {
    "express": "^5.2.1",
    "stripe": "^17.7.0"
  },
  "devDependencies": {
    "nodemon": "^3.1.9"
  }
}
`,
      readme: `# Stripe Hosted Checkout Demo

A minimal Express + vanilla JS app that demonstrates Stripe's hosted checkout (redirects to stripe.com/checkout).

## Setup

1. Ensure you have a [Node.js installation](https://docs.npmjs.com/downloading-and-installing-node-js-and-npm).
2. Download the project, unzip it, and \`cd\` into the project folder.
3. Open the project in your text editor of choice (e.g. \`code .\`, \`cursor .\`)
4. Create or log into your Stripe sandbox account, then get your API keys from [dashboard.stripe.com/test/apikeys](https://dashboard.stripe.com/test/apikeys).
5. Replace \`sk_test_...\` in \`server.js\` with your Sandbox secret key.
6. Install dependencies and start the server: \`npm install && npm start\`
7. Open [http://localhost:4242](http://localhost:4242) in a browser.
8. Click "Checkout" to be redirected to Stripe's hosted checkout page.
`,
    },
  },
};
